// extracted by mini-css-extract-plugin
export default {"group":"Shortcuts_group__tFaPk","groupname":"Shortcuts_groupname__ffHwg","main":"Shortcuts_main__QmtRZ","label":"Shortcuts_label__-U77U","codes":"Shortcuts_codes__8acoO"};